import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettings } from '../../utils/app.settings';
import { environment } from 'src/environments/environment';
import {
  IVerifyTokenResponse,
  IRefreshTokenResponse,
  IRefreshTokenApiResponse,
} from '../../interfaces/sso.interface';

@Injectable({
  providedIn: 'root',
})
export class SsoValidateTokenService {
  constructor(
    private http: HttpClient,
    private appSettings: AppSettings
  ) {}

  verifyToken(token: string): Observable<IVerifyTokenResponse> {
    return this.http.post<IVerifyTokenResponse>(
      this.appSettings.sso.urls.postVerifyToken,
      { token }
    );
  }

  refreshToken(refreshToken: string): Observable<IRefreshTokenResponse> {
    return this.http
      .post<any>(this.appSettings.sso.urls.refresh, {
        refreshToken,
      })
      .pipe(
        map(response => {

          // Verificar si la respuesta tiene data (estructura wrapper)
          if (response && response.data) {
            return response.data as IRefreshTokenResponse;
          } else if (
            response &&
            response.accessToken &&
            response.refreshToken
          ) {
            // Si la respuesta viene directamente con los tokens
            return response as IRefreshTokenResponse;
          } else {
            console.error('❌ Respuesta inválida del refresh token:', response);
            throw new Error('Invalid refresh token response structure');
          }
        })
      );
  }

  logout(token: string): Observable<void> {
    return this.http.post<void>(this.appSettings.sso.urls.logout, {
      accessToken: token,
    });
  }

  redirectToSso(): void {
    window.location.href = environment.sso.url;
  }
}
